import { render } from "./search-system.vue?vue&type=template&id=dc7db718"
import script from "./search-system.vue?vue&type=script&lang=js"
export * from "./search-system.vue?vue&type=script&lang=js"

import "./search-system.vue?vue&type=style&index=0&id=dc7db718&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__